let regionNames = null;
try {
  regionNames = new Intl.DisplayNames(["pt-BR"], { type: "region" });
} catch {
  regionNames = null;
}

export function countryNamePT(iso2, fallback) {
  try {
    return regionNames?.of(iso2) || fallback;
  } catch {
    return fallback;
  }
}

export function countryFlag(iso2) {
  if (!iso2 || iso2.length !== 2) return "";
  return String.fromCodePoint(...[...iso2.toUpperCase()].map(c => 0x1f1e6 + c.charCodeAt(0) - 65));
}
